import DummyLink from './DummyLink';

export default DummyLink;
